export default {
  name: 'account--account',
  apiService: 'account',
  apiPath: '/admin/acc',
};